import { computed } from 'vue';
import { deviceTypes } from '@utils/constants';
import useMeta from '@modules/discovery/composables/useMeta';
import { useDevice } from '@modules/discovery/composables';
import usePageType from '@modules/discovery/composables/usePageType';
import useEnvParams from '@composables/useEnvParams';
import { IGoogleAdPlaceholder } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

const CLASSES = {
  [deviceTypes.DESKTOP]: 'googleAdInlinePlaceHolder',
  [deviceTypes.PHONE]: 'googleAdInlinePlaceholder_Mobile',
};

/**
 *
 * @returns {IGoogleAdPlaceholder}
 */
export default function useGoogleAdInlinePlaceholder() {
  const { isPhone } = useDevice();
  const classes = computed(() => (isPhone ? CLASSES[deviceTypes.PHONE] : CLASSES[deviceTypes.DESKTOP]));
  const { sitePageType } = usePageType();
  const meta = useMeta();
  const isUSARegion = computed(() => meta?.value?.context?.regionCode === 'US');
  const isWeddingRegistry = computed(() => meta?.value?.context?.shoppingMode === 'WEDDING_REGISTRY');
  const deviceType = !isPhone ? 'desktop' : 'mobile';
  const { brand } = useEnvParams();

  return {
    classes,
    sitePageType,
    isUSARegion,
    isWeddingRegistry,
    deviceType,
    brand,
    pageBrand: meta?.value?.context?.brand,
  };
}
